import { render, staticRenderFns } from "./simDistributRecord.vue?vue&type=template&id=fecd1d58&scoped=true&"
import script from "./simDistributRecord.vue?vue&type=script&lang=js&"
export * from "./simDistributRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecd1d58",
  null
  
)

export default component.exports